import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";
import { isNullOrUndefined } from "../../../../utils/utils";
import {
  setAccounts,
  setSelectedAccount,
} from "../../../../redux/reducers/TransactionManager";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  updateAccountName,
  updateAccountNameTagLevels,
} from "../../../../docuclipper/api";
import { fetchTotals } from "../../../../redux/reducers/Reconciler";
import {
  fetchMfs,
  fetchTls,
} from "../../../../redux/reducers/TransactionManager";
import SelectWithBadge from "./SelectWithBadge";
import ClipLoader from "react-spinners/ClipLoader";
import { useL1L2Params } from "src/hooks/useL1L2Params";
type Props = {
  showAccountsHeading?: boolean;
  showEditAccountName?: boolean;
  renderReconciled?: any;
};
export const AccountSelector: React.FC<Props> = ({
  showAccountsHeading = true,
  showEditAccountName = true,
}) => {
  const dispatch = useDispatch();
  const { tls, selectedDocumentId, reconciled, selectedAccount, badDates } =
    useSelector((state: ReduxState) => state.TransactionManager);

  // const { tls: transactions } = tls;

  const { totalsByDocumentId } = useSelector(
    (state: ReduxState) => state.Reconciler
  );

  const accounts = Object.keys(
    totalsByDocumentId[selectedDocumentId as string] || {}
  );
  const { job } = useSelector((state: ReduxState) => state.JobData);

  const { l1, l2 } = useL1L2Params();

  const [showEditAccount, setShowEditAccount] = React.useState(false);
  const [newAccountName, setNewAccountName] = React.useState(selectedAccount);
  const [isUpdating, setIsUpdating] = React.useState(false);
  const toggleShowEditAccount = () => setShowEditAccount(!showEditAccount);

  React.useEffect(() => {
    setNewAccountName(selectedAccount);
  }, [selectedAccount]);

  React.useEffect(() => {
    if (!selectedAccount && accounts.length > 0) {
      dispatch(setSelectedAccount(accounts[0]));
    }
  }, [accounts]);

  React.useEffect(() => {
    if (accounts.length > 0) {
      dispatch(setSelectedAccount(accounts[0]));
    }
  }, [selectedDocumentId]);

  const options = accounts.map((accountName) => ({
    label: accountName,
    value: accountName,
    reconciled: reconciled.accounts[accountName],
    reconciledType: "account",
    isBadDate: badDates.accounts[accountName],
  }));

  // console.log({ selectedAccount, options, accounts, reconciled });
  return (
    <>
      {Object.keys(accounts).length > 0 && (
        <>
          <Row className="flex-column">
            <div
              className="d-flex"
              style={{
                justifyContent: "space-between",
                width: "95%",
              }}
            >
              {showAccountsHeading && (
                <span className="font-weight-bold">
                  Select Account ({accounts.length} available) ▾
                </span>
              )}
              {showEditAccountName && (
                <>
                  <Button
                    className="p-0"
                    variant="link"
                    onClick={toggleShowEditAccount}
                  >
                    <FontAwesomeIcon icon="cog" />
                    <span className="ml-1">Rename</span>
                  </Button>
                  <Modal show={showEditAccount} onHide={toggleShowEditAccount}>
                    <Modal.Header closeButton>
                      <Modal.Title>Rename Account</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Row>
                        <Col>
                          <Form.Group>
                            <Form.Label>Account Name</Form.Label>
                            <Form.Control
                              name="accountName"
                              value={newAccountName || ""}
                              onChange={(e) => {
                                setNewAccountName(e.target.value);
                              }}
                              type="text"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={toggleShowEditAccount}
                      >
                        Close
                      </Button>
                      <Button
                        variant="primary"
                        onClick={() => {
                          let fn;
                          if (l1 && l2) {
                            fn = updateAccountNameTagLevels({
                              l1,
                              l2,
                              documentId: selectedDocumentId,
                              newAccountName,
                              oldAccountName: selectedAccount,
                            });
                          } else if (job) {
                            fn = updateAccountName({
                              jobId: job.id,
                              documentId: selectedDocumentId,
                              newAccountName,
                              oldAccountName: selectedAccount,
                            });
                          }
                          setIsUpdating(true);
                          fn.then(() => {
                            // Update the selected account to the new name
                            dispatch(setSelectedAccount(newAccountName));
                            toggleShowEditAccount();
                            dispatch(fetchTotals());
                            // dispatch(fetchTls(false));
                            dispatch(fetchMfs());
                          })
                            .catch(() => {
                              toggleShowEditAccount();
                            })
                            .finally(() => {
                              setIsUpdating(false);
                            });
                        }}
                        disabled={isUpdating}
                        className=""
                      >
                        <span className="">
                          {isUpdating ? (
                            <>
                              <ClipLoader size={14} color="#ffffff" />{" "}
                              Renaming...
                            </>
                          ) : (
                            "Rename Account"
                          )}
                        </span>
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </>
              )}
            </div>

            <div style={{ width: "95%" }}>
              <SelectWithBadge
                value={
                  options.find((opt) => opt.value === selectedAccount) || null
                }
                onChange={(e) => {
                  dispatch(setSelectedAccount(e.value));
                }}
                options={options}
              />
            </div>
          </Row>
        </>
      )}
    </>
  );
};
export default AccountSelector;
